<template>
    <div class="scroll_container">
        <Scrollama @step-enter="stepEnterHandler" :offset="0.5" :once="true" id="2" >
            <div slot="graphic"  class="graphic" id="graphic2">
                <SitesCharts v-bind:highlightYear="this.highlightYear"/>
            </div>
               <div class="step step1_scrollama2" data-step="a">

                   <p>L’autorité des marchés financiers (AMF) est chargée de repérer et de lister les sites qui véhiculent des arnaques financières.</p>

               </div>
               <div class="step" data-step="b">

                   <p>Jusqu’en 2013, l’AMF détectait assez peu de sites frauduleux.</p>

               </div>

               <div class="step" data-step="c">
                   <p>En 2014, leur nombre décolle avec 113 sites. C’est le top départ des grandes vagues d’arnaques dites au « Forex » et aux « Options binaires ».
                   </p>

               </div>
               <div class="step" data-step="d">

                   <p>Début 2016, le gouvernement et le parquet de Paris alertent sur la fraude massive aux options binaires. Le filon se tarit.
                   </p>

               </div>
               <div class="step" data-step="e">

                   <p>En 2017, les publicités pour les "options binaires" sont interdites. Mais les taux d’intérêts sont au plus bas, les épargnants sont à la recherche de placements alternatifs, les escrocs jouent désormais la carte du « concret »  avec de faux investissements sur les diamants. </p>

               </div>
               <div class="step" data-step="f">

                   <p>Fin 2017 et 2018, la montée du bitcoins et des autres cryptomonnaies provoque une fièvre chez les épargnants. Les sites frauduleux de vente de faux bitcoins fleurissent un peu partout.</p>

               </div>
               <div class="step" data-step="g">

                   <p>Entre 2019 et 2022, les arnaques financières se sont peu à peu déplacées vers de faux placements sur des grands crus (champagne, vin etc.) ainsi que vers les sites vendant de fausses formations au trading.</p>

               </div>


        </Scrollama>
    </div>
</template>

<script>
    import "intersection-observer"; // for cross-browser support
    import Scrollama from "vue-scrollama";
    import SitesCharts from "@/components/chartsHandler/SitesCharts.vue"
    export default {
        components: {
            Scrollama,
            SitesCharts
        },
        data(){
            return {
                highlightYear : 2010,
        }
        },
        methods:{
            stepEnterHandler({element, index, direction}){
                console.log(element, index, direction)
                if (index == 1) {
                    this.highlightYear = 2013;
                } else if (index == 2) {
                    this.highlightYear = 2014;

                } else if (index == 3) {
                    this.highlightYear = 2016;
                } else if (index == 4) {
                    this.highlightYear = 2017;

                } else if (index == 5) {
                    this.highlightYear = 2019;

                }
            }

        }

  };
</script>
<style src="vue-scrollama/dist/vue-scrollama.css"></style>


<style>

#scrollama-container-2 {
                          display: flex;
                          flex-direction: row;
                          margin-top:5%;
                          justify-content:center;
                      }



#scrollama-container-2 .scrollama-graphic {
    /*flex: 2;*/
    height: 70vh;
    top: 20vh;
    width:50%;
}

#scrollama-container-2 .scrollama-steps {
    /*flex: 1;*/
    width:30%;


}

@media screen and (max-width:1000px) and (min-width:601px) {

    #scrollama-container-2 .scrollama-steps {
        width: 25vw;
        text-align: center;
    }



    #scrollama-container-2 {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-bottom:10vh;
        width: 100vw;
    }


    #scrollama-container-2 .scrollama-graphic {
        /*flex: 2;*/
        height: 50vh;
        top: 12vh;
        width:60vw;
    }



}






@media screen and (max-width:600px) {

    #scrollama-container-2 .scrollama-steps {
        /*flex: 1;*/
        width: 100%;
        text-align: center;
    }



    #scrollama-container-2 {
        display: flex;
        flex-direction: column;
        margin-bottom:10vh;
        width: 100vw;
    }


    #scrollama-container-2 .scrollama-graphic {
        /*flex: 2;*/
        height: 50vh;
        top: 12vh;
        width: 100%;
    }



}


</style>
    <style scoped>
      .step {
         width:100%;
         margin-top: 30%;
         margin-bottom:10%;
         padding:2%;
         background-color:rgba(255, 255, 255, 1);
         /*box-shadow: -1px -1px 5px -1px rgba(0, 0, 0, 0.19), 1px 3px 5px 0px rgba(0, 0, 0, 0.19);*/
         display: flex;
         justify-content:center;
         align-items:flex-start;
     }

    .graphic {
        height: 80%;
         margin: 0 3rem;
        display: flex;
        align-items:center;
        justify-content: center;
        font-size: 5rem;
    }





        @media screen and (max-width:600px) {
            .step {
                width: 90vw;
                margin-top: 30%;
                margin-bottom: 100%;
                padding: 5vw;
                background-color: rgba(255, 255, 255, 1);
                display: flex;
                justify-content: center;

                    }


            .graphic {
                height: auto;
                width:100vw;
                margin:0px;
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
            }
        }
</style>


